module.exports = __webpack_public_path__ + "fonts/84d078d8f1a2bf1544c4c9855a928872.svg";